import { render, staticRenderFns } from "./currencymod.vue?vue&type=template&id=16c6893a&"
import script from "./currencymod.vue?vue&type=script&lang=js&"
export * from "./currencymod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16c6893a')) {
      api.createRecord('16c6893a', component.options)
    } else {
      api.reload('16c6893a', component.options)
    }
    module.hot.accept("./currencymod.vue?vue&type=template&id=16c6893a&", function () {
      api.rerender('16c6893a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FjZvep5eBrPq/JS/comp/currencymod.vue"
export default component.exports